import { render } from "./Copyable.vue?vue&type=template&id=9dce7df2&scoped=true"
import script from "./Copyable.vue?vue&type=script&lang=js"
export * from "./Copyable.vue?vue&type=script&lang=js"

import "./Copyable.vue?vue&type=style&index=0&id=9dce7df2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dce7df2"]])

export default __exports__